require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/embed.css');
require('ta-semantic-ui/semantic/dist/components/message.css');
require('ta-semantic-ui/semantic/dist/components/item.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/label.css');
require('styles/App.css');

const oscarStatue = require('./oscar.svg');
const oscarStatueOutline = require('./oscar-outline.svg');
const mostAwardedFilms = require('./most-awarded-films.csv');
const allWinners = require('./all-winners.csv');

import React from 'react';
import Masthead from '@ta-interaktiv/react-polymorphic-masthead';
import Tracking from 'ta-react-polymorphic-tracking';
import ArticleTeasers from '@ta-interaktiv/react-article-teasers';
import CopyrightNotice from 'ta-react-polymorphic-copyright-notice';
import ShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons';
import SetCard from './setCard';
import MostAwarded from './mostAwarded';
import Dimensions from 'react-dimensions';

class AppComponent extends React.Component {
  render() {
    return (
      <div className='index' style={{
        backgroundImage: `url(${require('./background.png')}) `,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top center'
      }}>
        <Masthead articleID='30660020' hashtags={['oscars2017']} inverted />

        <header className='ui vertical segment' style={{
          backgroundImage: `url(${require('./oscar-detailed.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'right',
        }}>
          <div className='ui container'>
            <h1 className='ui huge center very fitted aligned brown header'
                style={{fontSize: '290%'}}>
              <div className='sub header'>Oscar-Verleihung 2017</div>
              Die Gewinner
            </h1>
            {/*<p className=''>*/}
              {/*<img src={require('./oscar.svg')}*/}
                   {/*className='ui mini centered image'*/}
                   {/*style={{*/}
                     {/*width: '18px'*/}
                   {/*}}*/}
                   {/*alt=''/>*/}
              {/*Gewonnene Oscars*/}
            {/*</p>*/}
          </div>
        </header>

        <article className='ui vertical segment'>
          <div className='ui container'>

            <div className='ui grid'>
              <div className='ui two column centered row'>
                {
                  mostAwardedFilms.slice(0, 1).map((film, index) => {
                    return <MostAwarded Columns={2} key={index} {...film} />
                  })
                }

              </div>
            </div>
            <div className='ui stackable grid'>
            <div
                className='ui two columns centered row'
              >
                {
                  mostAwardedFilms.slice(1, 3).map((film, index) => {
                    return <MostAwarded Columns={1} key={index} {...film} />
                  })
                }
              </div>
            </div>


            <div className='ui two column stackable vertically divided grid'>
              <div className='one column row'>
                <div className='column'>
                  <SetCard category='Bester Film' name='Moonlight'
                           image={require('./images/moonlight.jpg')}
                           imageSize={this.props.containerWidth < 599 ? 'small' : 'large'}
                           trailer='https://www.youtube.com/watch?v=9NJj12tJzqc'
                  >Das Drama «Moonlight» wird zum besten Film gekürt, nachdem Favorit «La La Land» für einen kurzen Moment als Sieger dastand. Die Bekanntgabe des Siegers in der Königskategorie wurde zum totalen Durcheinander: Zunächst wurde fälschlicherweise «La La Land» als Gewinner ausgerufen. Als Moderator Jimmy Kimmel nach grosser Verwirrung für Aufklärung sorgte, übergab «La La Land»-Produzent Jordan Horwitz die Trophäe an das Team von «Moonlight». Das Drama erzählt vom Erwachsenwerden des jungen Schwarzen Chiron aus einer rauen Gegend in Miami, der seine Homosexualität entdeckt. In dem Film spielt Naomi Harris dessen drogensüchtige Mutter und Mahershala Ali einen Drogendealer, der zu dessen Mentor wird. Für seine Rolle erhielt Ali den Oscar als bester Nebendarsteller.</SetCard>

                </div>
              </div>


              <div className='divided two column row'>
                <div className='column'>
                  <SetCard name='Casey Affleck'
                           image={require('./images/caseyaffleck.jpg')}
                           category='Bester Hauptdarsteller'
                           film='Manchester by the Sea'
                           trailer='https://www.youtube.com/watch?v=gsVoD0pTge0'
                  >
                    Der 41-jährige Casey Affleck spielt in «Manchester by the Sea» einen Hausmeister, der unter dem Verlust seiner Kinder leidet und mit einem weiteren Todesfall in seiner Familie konfrontiert wird.
Es ist der erste Oscar für Affleck. In seiner Dankesrede würdigte er Denzel Washington. Dieser habe ihm die Schauspielerei beigebracht, obschon er ihn vor der Gala vom Sonntag nie getroffen habe.
                  </SetCard>
                </div>
                <div className='column'>
                  <SetCard category='Beste Hauptdarstellerin'
                           name='Emma Stone'
                           film='La La Land'
                           image={require('./images/emmastone.jpg')}
                           trailer='https://www.youtube.com/watch?v=0pdqf4P9MB8'
                  >
                    Emma Stone verkörpert in «La La Land» die ambitionierte Schauspielerin Mia, die unter gescheiterten Castings leidet und sich mit einem Job in einem Café durchs Leben hangelt. Ein ebenfalls beruflich zunächst nicht sehr erfolgreicher Jazzpianist, gespielt von Ryan Gosling, gibt ihr aber neuen Schwung. Auch für Stone war es der erste Oscar.
                  </SetCard>
                </div>
              </div>

              <div className='divided two column row'>
                <div className='column'>
                  <SetCard category='Bester Nebendarsteller'
                           name='Mahershala Ali'
                           film='Moonlight'
                           image={require('./images/alimahershala.jpg')}
                           trailer='https://www.youtube.com/watch?v=9NJj12tJzqc'
                  >Mahershala Ali bekam für seine Leistung in dem Drama «Moonlight» den Oscar als bester Nebendarsteller verliehen. Der 43-jährige US-Amerikaner spielt darin einen kubanischen Drogenhändler in Miami, der zum Ersatzvater für einen gemobbten Jungen wird und versucht, ihm emotionale Untersützung zu bieten.
                  </SetCard>
                </div>
                <div className='column'>
                  <SetCard category='Beste Nebendarstellerin'
                           name='Viola Davis'
                           film='Fences'
                           image={require('./images/violadavis.jpg')}
                           trailer='https://www.youtube.com/watch?v=a2m6Jvp0bUw'
                  >
                  Das Drama «Fences» erzählt von einem afroamerikanischen Paar in den USA der 1950er Jahre. Die 51-jährige Viola Davis porträtiert Rose Maxson, eine hingebungsvolle Frau und Mutter, die versucht, die Ambitionen ihres Sohnes gegen den manchmal wilden Spott ihres Mannes zu meistern.
                  Regie führte Denzel Washington, der im Film auch selbst die Hauptrolle spielt.
                  </SetCard>
                </div>
              </div>

              {/*<div className='divided two column row'>*/}
                {/*<div className='column'>*/}
                  {/*<SetCard image={require('./images/violadavis.jpg')}*/}
                           {/*category='Beste Regie'*/}
                           {/*name='Steven Spielberg'*/}
                           {/*imageSize='small'*/}
                           {/*film='Filmname'*/}
                           {/*trailer='https://www.youtube.com/watch?v=gsVoD0pTge0'*/}
                  {/*>*/}
                    {/*As Michèle, Isabelle Huppert plays a successful CEO*/}
                    {/*who*/}
                    {/*refuses to go to the police when she is raped, instead*/}
                    {/*resolving to find the culprit on her own.*/}
                  {/*</SetCard>*/}
                {/*</div>*/}
                {/*<div className='column'>*/}
                {/*</div>*/}
              {/*</div>*/}

            </div>

            <div className='ui divider'></div>
            <br/>

            <div
              className='ui three column doubling stackable centered relaxed grid'>
              {allWinners.map((contestant, index) => {
                return (

                  <div
                    className='center aligned column'
                    key={index}

                  >
                    {/*<div className='ui fluid image'>*/}
                      {/*<a className='ui right corner label'>*/}
                        {/*<i className='play icon'></i>*/}
                      {/*</a>*/}
                    {/*</div>*/}
                    <img src={require('./oscar.svg')}
                         className='ui mini centered image'
                         alt=''/>
                    <h3 className={`ui small brown centered header ${contestant.fontSizeAward ? 'small' : ''}`}
                        style={{
                          marginTop: '1ex',
                          marginBottom: '5px'
                        }}>
                      {contestant.Kategorie}
                    </h3>
                    <p
                      className={contestant.fontSizeMovie ? 'small' : ''}
                    >
                      {contestant.Film}
                    </p>
                    {contestant.Trailer &&
                      <a
                        className='ui tiny label'
                        href={contestant.Trailer ? contestant.Trailer : ''}
                        target='_blank'
                      >
                        <i className='play icon'></i>
                        Trailer
                      </a>
                    }
                    <div className='ui divider'>
                    </div>
                  </div>
                )
              })}
            </div>

          </div>
        </article>


        <footer className='ui grey inverted vertical very fitted segment'>
          <div className='ui container'>
            <div className='ui inverted divided stackable grid'>
              <div className='ui two column bottom aligned mobile reversed row'>
                <div className='column'>



                  <table
                    className='ui definition inverted infographic very basic table'>
                    <tbody>
                    <tr>
                      <td>Illustrationen</td>
                      <td>Jürg Candrian</td>
                    </tr>

                    <tr>
                      <td>Online-Umsetzung</td>
                      <td>Kaspar Manz, Marc Fehr</td>
                    </tr>

                    </tbody>
                  </table>

                  <div className='ui horizontal divider'></div>

                  <ShareButtons articleID='30660020' hashtags={['oscars2017']}/>
                  <div className='ui hidden section divider'></div>
                  <CopyrightNotice inverted/>
                  <Tracking articleId='30660020' />
                </div>
                <div className='column'>
                  <h2 className='ui tiny infographic inverted header'>
                    Mehr Artikel zum Thema
                  </h2>
                  <ArticleTeasers articleIds={['17066526', '14988528', '22075045']}
                                  numberOfCards='one'/>
                </div>
              </div>
            </div>
          </div>
        </footer>



      </div>
    );
  }
}

AppComponent.defaultProps = {};

AppComponent.propTypes = {
  containerWidth: React.PropTypes.number
};

export default Dimensions() (AppComponent);



// WEBPACK FOOTER //
// ./src/components/main/Main.js